import axiosInstance from '../config/axios.config';
import ENDPOINTS from '../config/endpoints';

const unwrapTrackingResponse = (responseData) => {
  if (responseData?.data) {
    return responseData.data;
  }

  return responseData;
};

const shippingService = {
  // Tracking is fetched by order - the order itself may not carry a carrier or
  // tracking number yet, and this endpoint returns both once a label exists
  async getTrackingByOrder(orderUuid) {
    if (!orderUuid) {
      throw new Error('Order ID is required');
    }

    try {
      const response = await axiosInstance.get(ENDPOINTS.SHIPPING.TRACKING_BY_ORDER(orderUuid));
      return unwrapTrackingResponse(response.data);
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        'Unable to load tracking details right now.';

      throw new Error(message);
    }
  },

  async getTracking(carrier, trackingNumber) {
    if (!carrier || !trackingNumber) {
      throw new Error('Carrier and tracking number are required');
    }

    try {
      const response = await axiosInstance.get(ENDPOINTS.SHIPPING.TRACKING(carrier, trackingNumber));
      return unwrapTrackingResponse(response.data);
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        'Unable to load tracking details right now.';

      throw new Error(message);
    }
  },
};

export default shippingService;
